import React from 'react';
import PropTypes from 'prop-types';
import Fullscreen from '@99designs/fullscreen';
import SidebarHeader from '@99designs/ddo/components/SidebarHeader';
import AsyncCommentPane from '@99designs/ddo/components/AsyncCommentPane';
import Button from '@99designs/react-components/components/Button';
import DesignActions from 'apps/designdetails/components/DesignActions';
import DesignMetadata from './DesignMetadata';

export default class DesignDetailsSidebar extends React.Component {
    designActionsSection() {
        return (
            <DesignActions
                design={this.props.design}
                activeUser={this.props.activeUser}
            />
        );
    }

    marketingButton() {
        if (this.props.design.marketingCtaButton) {
            return (
                <Button
                    variations={['fluid', 'secondary']}
                    href={this.buttonUrl()}
                >
                    { this.buttonText() }
                </Button>
            );
        }

        return null;
    }

    commentSection() {
        if (this.props.design.permission.userIdentified) {
            return (
                <AsyncCommentPane
                    design={this.props.design}
                    activeUser={this.props.activeUser}
                    isLoadingComments={this.props.isLoadingComments}
                    comments={this.props.comments}
                    selectedComment={this.props.selectedComment}
                    selectedCommentStatus={this.props.selectedCommentStatus}
                    selectedCommentEditingLocation={this.props.selectedCommentEditingLocation}
                />
            );
        }

        return null;
    }

    buttonText() {
        return this.props.design.marketingCtaButton.text;
    }

    buttonUrl() {
        return this.props.design.marketingCtaButton.url;
    }

    render() {
        return (
            <Fullscreen.Sidebar.Main>
                <Fullscreen.Sidebar.Header>
                    <SidebarHeader.Main
                        closeOverlayHandler={this.props.closeOverlayHandler}
                        isCloseButtonEnabled={this.props.isInline}
                    >
                        { this.designActionsSection() }
                    </SidebarHeader.Main>
                </Fullscreen.Sidebar.Header>
                <Fullscreen.Sidebar.Body>
                    <div className="sidebar-body__section">
                        <DesignMetadata design={this.props.design} />
                        { this.marketingButton() }
                    </div>
                    { this.commentSection() }
                </Fullscreen.Sidebar.Body>
            </Fullscreen.Sidebar.Main>
        );
    }
}

DesignDetailsSidebar.contextTypes = {
    intl: PropTypes.object,
};

DesignDetailsSidebar.defaultProps = {
    selectedComment: null,
    selectedCommentStatus: null,
    selectedCommentEditingLocation: null,
};

DesignDetailsSidebar.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    closeOverlayHandler: PropTypes.func.isRequired,
    isInline: PropTypes.bool.isRequired,
    isLoadingComments: PropTypes.bool.isRequired,
    comments: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
    selectedComment: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    selectedCommentStatus: PropTypes.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    selectedCommentEditingLocation: PropTypes.oneOf(['canvas', 'pane', null]),
    activeUser: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/designdetails/components/DesignDetailsSidebar.jsx